import request from '@/utils/request'
const qs = require('qs')

// 账号密码登录
export function loginByUsername (data) {
  return request({
    url: '/ooh-os/v1/login',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 企业微信扫码登录
export function loginByWeixin (data) {
  return request({
    url: '/ooh-os/v1/wxlogin',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 微信扫码登录
export function wechatLogin (data) {
  return request({
    url: '/ooh-os/v1/wechatLogin',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 绑定企业微信
export function bindqywx (data) {
  return request({
    url: '/ooh-os/v1/bindqywx',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取公众号二维码
export function getwxcode (data) {
  return request({
    url: '/ooh-auth/oauth/getqrcode',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 二维码是否扫码、失效。已扫码返回msg为openId
export function checkqrcode (data) {
  return request({
    url: '/ooh-os/v1/checkqrcode',
    method: 'post',
    data: qs.stringify(data)
  })
}
